<template>
  <div class="switchBar">
    <el-tabs
      v-model="activeName"
      type="card"
      class="demo-tabs"
      @tab-click="handleClick"
    >
      <el-tab-pane label="普通用户" name="first"></el-tab-pane>
      <el-tab-pane label="管理用户" name="second"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="头像">
        <template #default="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.headPic"
            :fit="'contain'"
          />
        </template>
      </el-table-column>
      <el-table-column label="id" prop="id" />
      <el-table-column label="昵称" prop="name" />
      <el-table-column label="账户名" prop="username" />
      <el-table-column label="账号类型" prop="type" />
      <el-table-column label="创建时间" prop="createTime" />
      <el-table-column align="right">
        <template #default="scope">
          <el-button
            v-if="activeName == 'second'"
            type="danger"
            size="default"
            @click="quash(0, scope.row)"
            >转为普通用户</el-button
          >
          <el-button
            v-if="activeName == 'first'"
            type="success"
            size="default"
            @click="quash(2, scope.row)"
            >转为管理用户</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>

  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox, TabsPaneContext } from "element-plus";
import { Form } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      tableData: [],
      status: 0,
      centerDialogVisible: false,
      form: {
        allowCreate: 0,
        createTime: "",
        headPic: "",
        id: "",
        name: "",
        password: "",
        remark: "",
        status: 1,
        type: "",
        username: "",
      },
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.gameCover !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {},
  created() {
    this.fetchGameList(this.currentPage, this.status);
  },
  methods: {
    fetchGameList(pageNum: number, status: number) {
      const pageSize = 10;
      this.$store
        .dispatch("user/getUserList", { pageNum, pageSize, status })
        .then((res: any) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "warning",
          });
        });
    },
    handleCurrentChange(val: number) {
      this.fetchGameList(val, this.status);
    },
    handleEdit(index: number, row: Form) {
      this.form = row;
    },
    handleClick(tab: TabsPaneContext) {
      this.status = tab.paneName === "first" ? 0 : 2;
      this.fetchGameList(1, this.status);
    },
    quash(index: number, data: any) {
      this.updateGame(index, data.id);
    },
    updateGame(status: number, userId: string) {
      this.$store
        .dispatch("game/UpdateUserStatus", { status: status, userId: userId })
        .then((res: any) => {
          this.handleCurrentChange(this.currentPage);
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
